import { logError, logMessage } from '@marketplace-web/observability/logging-util'

const MESSAGING = 'real-time-messaging'

export const logSSEMessage = (message: string, extra?: string) =>
  logMessage(message, { feature: MESSAGING, ...(extra && { extra }) })

export const logSSEError = (error: Error, extra?: string) =>
  logError(error, { feature: MESSAGING, ...(extra && { extra }) })
